module.exports = __webpack_public_path__ + "img/4W.9fb3cce5.png";